export default __webpack_public_path__ + "static/media/subtitle-icon.3ae177a4.svg";